

export const draggableNavigation =  {

    namespaced: true,

    getters: {
        menus(state, getters) {
            return [
                {
                    id: 1,
                    title: 'Dashboard',
                    name: 'Dashboard',
                    iconKey: 'mdi-home',
                    pageSwitchKey: 'dashboard_page',
                },
                {
                    id: 2,
                    title: 'Accounts',
                    name: 'Accounts',
                    iconKey: 'mdi-bank',
                    pageSwitchKey: 'accounts_page',
                },
                {
                    id: 3,
                    title: 'Performance',
                    name: 'YearToDatePerformance',
                    iconKey: 'mdi-chart-line',
                    pageSwitchKey: 'performance_page',

                },
                // {
                //     id: 4,
                //     title: 'Positions',
                //     name: 'Positions',
                //     iconKey: 'mdi-chart-pie',
                //     pageSwitchKey: 'positions_page',
                // },
                {
                    id: 6,
                    title: 'Net Worth',
                    name: 'NetWorth',
                    iconKey: 'mdi-currency-usd',
                    pageSwitchKey: 'networth_page',
                },
                getters.myPlanPage

            ]
        },

        homePage(state, getters, rootState, rootGetters) {
            let topPageId = rootGetters['auth/userNavigationOrder'][0];
            return getters.menus.find( page => page.id === topPageId);
        },

        myPlanPage(state, getters, rootState, rootGetters) {
            if (rootGetters['household/isClientHouseholdWithNoIncomePlaner']) {
                return {
                    id: 5,
                    title: 'Create My Plan',
                    name: 'CreateIncomePlanner',
                    iconKey: 'mdi-calculator',
                    pageSwitchKey: 'my_plan_page',
                };
            }

            return {
                id: 5,
                title: 'See My Plan',
                name: 'IncomePlanner',
                iconKey: 'mdi-calculator',
                pageSwitchKey: 'my_plan_page',
            };
        },

        orderedMenu(state, getters, rootState, rootGetters) {
            let menusUserOrdered = [];
            let orderedPageIds = rootGetters['auth/userNavigationOrder'];
            let unsavedMenus = [];

            // Find unsaved, ex: new pages
            for (let i = 0; i < getters.menus.length; i++) {
                let menu = getters.menus[i];
                let menuUnsaved = orderedPageIds.find(id => id === menu.id) === undefined;
                if (menuUnsaved) {
                    unsavedMenus.push(menu);
                }
            }

            for (let i = 0; i < orderedPageIds.length; i++) {
                let menu = getters.menus.find( menu => menu.id === orderedPageIds[i]);
                if (menu) {
                    menusUserOrdered.push(menu);
                }
            }

            menusUserOrdered = [...menusUserOrdered, ...unsavedMenus]

            // // Don't show pages that are performance related if the integration isn't available.
            // if (!rootState.household.integrationStatus.performance_reporting_active) {
            //     return menusUserOrdered.filter((nav) => {
            //         return nav.name !== 'Positions' && nav.name !== 'YearToDatePerformance';
            //     })
            // }

            return menusUserOrdered;
        }

    }
}
